import { getCancellationReasons } from './GetCancellationReasons';
import { submitCancellationFeedback } from './SubmitCancellationFeedback';

export const CancellationReasonsService = {
  getCancellationReasons,
  submitCancellationFeedback,
};
